import { withAsync } from '@/components'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/error',
    component: withAsync(() => import(/* webpackChunkName: "Error/NotFoundPage" */ '@/containers/NotFoundPage')),
    exact: true,
  },
  {
    path: '/authority',
    component: withAsync(() => import(/* webpackChunkName: "Error/authority" */ '@/containers/User/Authority')),
    exact: true,
  },
]

export default routes
